export default function HeatByHeatIndividualLap(){
  
  const error = () => console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",);
  
  if($('#hbh-individual-lap').length){
    const eventUrl = window.location.pathname.split('/')
    const eventSanction = eventUrl[2] 
    const eventID = eventUrl[4]
    const eventName = eventUrl[5].replace(/-/g, ' ');
    const loaded = (target) => $(target).addClass('loaded')

    $(`#session-name`).html(eventName)

    $.ajax( {
      url: `https://data-aws.amaproracing.com/api/reporting/individualtimes/${eventID}`,
      method: 'GET',
      dataType: 'json',
      error: () => error(),
      success: data => {
        const results = data[0].IndividualTimes
        const container = $('#il-content')
        let content = ``
        let counter = 1
        for (let result of results){
          const bikeLogo = `/wp-content/themes/smx/dist/img/sx-manufacturer-logos/${result.Bike}.png`

          content += `<div class="il-table-col">`
          content += `  <div class="il-table-row heading">`
          content += `    <div class="il-table-inner-col">`
          content += `      <span class="position">${counter}</span>`
          content += `    </div>`
          content += `    <div class="il-table-inner-col">`
          content += `      <span class="name">${result.FullName}</span>`
          content += `      <span class="team"><img src="${bikeLogo}"></span>`
          content += `    </div>`
          content += `  </div>`
          content += `  <div class="content">`
          for (let lap of result.Laps){
            content += `    <div class="il-table-row body">`
            content += `      <div class="il-table-inner-col">${lap.LapNum}</div>`
            content += `      <div class="il-table-inner-col">${lap.LapTimeText}</div>`
            content += `    </div>`
          }
          content += `    <div class="il-table-row bold">`
          content += `      <div class="il-table-inner-col">Max</div>`
          content += `      <div class="il-table-inner-col">${result.MaxLaptimeText}</div>`
          content += `    </div>`
          content += `    <div class="il-table-row bold red">`
          content += `      <div class="il-table-inner-col">Best</div>`
          content += `      <div class="il-table-inner-col">${result.BestLaptimeText}</div>`
          content += `    </div>`
          content += `    <div class="il-table-row bold">`
          content += `      <div class="il-table-inner-col">Avg</div>`
          content += `      <div class="il-table-inner-col">${result.AvgLaptimeText}</div>`
          content += `    </div>`
          content += `  </div>`
          content += `  <button class="il-view-all btn btn-purple btn-small mobile">view more</button>`
          content += `</div>`

          counter ++
        }
        container.html(content)
        loaded('#hbh-individual-lap')
        $('.il-view-all').click(function(){
          if($(this).html() === 'view more'){
            $(this).html('view less')
          }else{
            $(this).html('view more')
          }
          $(this).parent().toggleClass('active')
        })
      }
    });
  }


}